export const ssapPreviousData = {
    'appType': 'OE',
    'applicationType': 'OE',
    'applicationStatus': null,
    'coverageYear': 2022,
    'eligibilityStatus': 'PE',
    'currentPage': 1,
    'maxAchievedPage': 1,
    'finalized': false,
    'acceptPrivacyIndicator': true,
    'ssapApplicationId': '990077',
    'iP': null,
    'applicationGuid': '1000681533',
    'applicationSignatureDate': null,
    'getHelpIndicator': 'UNSPECIFIED',
    'helpType': null,
    'authorizedRepresentative': {
        'signatureisProofIndicator': null,
        'phone': [
            {
                'phoneExtension': null,
                'phoneNumber': null,
                'phoneType': 'CELL'
            },
            {
                'phoneExtension': null,
                'phoneNumber': null,
                'phoneType': 'HOME'
            },
            {
                'phoneExtension': null,
                'phoneNumber': null,
                'phoneType': 'WORK'
            }
        ],
        'partOfOrganizationIndicator': null,
        'address': {
            'postalCode': null,
            'county': null,
            'primaryAddressCountyFipsCode': null,
            'streetAddress1': null,
            'streetAddress2': null,
            'state': null,
            'city': null,
            'countyCode': null,
            'addressId': 0
        },
        'name': {
            'middleName': null,
            'lastName': null,
            'firstName': null,
            'suffix': null
        },
        'emailAddress': null,
        'organizationId': null,
        'companyName': null,
        'hasUserElectronicallySigned': null
    },
    'applyingForhouseHold': null,
    'applyingForFinancialAssistanceIndicator': true,
    'consentAgreement': null,
    'agreeToUseIncomeData': null,
    'agreeToEndCoverage': null,
    'numberOfYearsAgreed': '',
    'authorizedRepresentativeIndicator': null,
    'applicationStartDate': 1637123086000,
    'applicationDate': 1637123086000,
    'taxFilerDependants': [],
    'isRidpVerified': false,
    'clientIp': '192.168.67.211',
    'primaryTaxFilerPersonId': null,
    'broker': {
        'internalBrokerId': null,
        'brokerFederalTaxIdNumber': null,
        'brokerName': null,
        'brokerFirstName': null,
        'brokerLastName': null
    },
    'assister': {
        'assisterName': null,
        'assisterFirstName': null,
        'assisterLastName': null,
        'assisterID': null,
        'internalAssisterId': null
    },
    'taxHousehold': [
        {
            'householdMember': [
                {
                    healthReimbursementArrangement: [],
                    seeksQhp: true,
                    applicantPersonType: 'PC_PTF',
                    flagBucket: {
                        taxHouseholdCompositionFlags: 604587156,
                        taxHouseholdCompositionProgressFlags: 21650,
                        annualTaxIncomeFlags: 18
                    },
                    emergencyContactInfo: {
                        name: {
                            firstName: 'John',
                            middleName: 'Fitzgerald',
                            lastName: 'Kennedy',
                            suffix: 'Jr.'
                        },
                        phone: {
                            phoneExtension: '1001',
                            phoneNumber: '4084991234',
                            phoneType: 'HOME'
                        },
                        emailAddress: 'emergency_email@gmail.com'
                    },
                    taxHouseholdComposition: {
                        married: null,
                        taxFiler: null,
                        claimingDependents: null,
                        taxDependent: null,
                        claimedOutsideHousehold: false,
                        spouseMatch: null,
                        livesWithSpouse: null,
                        taxFilingStatus: 'FILING_JOINTLY',
                        taxRelationship: 'FILER',
                        claimerIds: [],
                        independentTaxFiler: false
                    },
                    parentCaretaker: null,
                    fullTimeStudent: null,
                    employerSponsoredCoverage: [
                        {
                            companyName: 'Air France',
                            applicantGuid: '1001002145',
                            memberName: 'David John Blacksmith Jr.',
                            name: {
                                firstName: 'Mike',
                                middleName: 'Daniel',
                                lastName: 'Hunter',
                                suffix: 'III'
                            },
                            phone: '2222222222',
                            email: 'mike_hunter@airfrance.com',
                            address: {
                                postalCode: '95136',
                                county: null,
                                streetAddress1: '1st street',
                                streetAddress2: 'suit 200',
                                state: 'CA',
                                city: 'San Jose'
                            },
                            ein: '1234567',
                            minimumValuePlan: true,
                            employerPremium: 110000,
                            employerPremiumFrequency: 'UNSPECIFIED',
                            employerOfferAffordable: false,
                            escOfferType: 'SelfOnlyCoverage'
                        }
                    ],
                    healthCoverage: {
                        chpInsurance: {
                            reasonInsuranceEndedOther: '',
                            insuranceEndedDuringWaitingPeriodIndicator: false
                        },
                        haveBeenUninsuredInLast6MonthsIndicator: null,
                        currentEmployer: [
                            {
                                employer: {
                                    phone: {
                                        phoneExtension: '',
                                        phoneNumber: '',
                                        phoneType: 'HOME'
                                    },
                                    employerContactPersonName: '',
                                    employerContactEmailAddress: ''
                                },
                                currentEmployerInsurance: {
                                    currentLowestCostSelfOnlyPlanName: '',
                                    willBeEnrolledInEmployerPlanIndicator: false,
                                    memberEmployerPlanStartDate: null,
                                    willBeEnrolledInEmployerPlanDate: null,
                                    comingPlanMeetsMinimumStandardIndicator: false,
                                    memberPlansToDropEmployerPlanIndicator: true,
                                    employerWillOfferPlanIndicator: true,
                                    expectedChangesToEmployerCoverageIndicator: true,
                                    employerCoverageEndingDate: null,
                                    memberPlansToEnrollInEmployerPlanIndicator: true,
                                    employerPlanStartDate: null,
                                    memberEmployerPlanEndingDate: null,
                                    comingLowestCostSelfOnlyPlanName: '',
                                    currentPlanMeetsMinimumStandardIndicator: false,
                                    employerWillNotOfferCoverageIndicator: false,
                                    isCurrentlyEnrolledInEmployerPlanIndicator: false,
                                    insuranceName: null,
                                    policyNumber: null
                                }
                            }
                        ],
                        currentlyHasHealthInsuranceIndicator: true,
                        currentOtherInsurance: {
                            otherStateOrFederalMedicaidProgramName: 'Medicaid',
                            otherStateOrFederalCHIPProgramName: 'Nevada Check Up',
                            otherStateOrFederalPrograms: [
                                {
                                    name: 'CHIP',
                                    type: 'CHIP',
                                    eligible: true
                                },
                                {
                                    name: 'COBRA Coverage',
                                    type: 'COBRA_COVERAGE',
                                    eligible: false
                                },
                                {
                                    name: 'Marketplace Coverage',
                                    type: 'MARKETPLACE_COVERAGE',
                                    eligible: false
                                },
                                {
                                    name: 'Medicaid',
                                    type: 'MEDICAID',
                                    eligible: false
                                },
                                {
                                    name: 'Medicare',
                                    type: 'MEDICARE',
                                    eligible: false
                                },
                                {
                                    name: 'Peace Corps',
                                    type: 'PEACE_CORPS',
                                    eligible: false
                                },
                                {
                                    name: 'Retire Health Benefits',
                                    type: 'RETIRE_HEALTH_BENEFITS',
                                    eligible: false
                                },
                                {
                                    name: 'TRICARE',
                                    type: 'TRICARE',
                                    eligible: false
                                },
                                {
                                    name: 'Veterans Affairs (VA) Health Care Program',
                                    type: 'VETERANS_AFFAIRS_HCP',
                                    eligible: false
                                },
                                {
                                    name: 'Other Coverage',
                                    type: 'OTHER_COVERAGE',
                                    eligible: true
                                },
                                {
                                    name: 'None Of the Above',
                                    type: 'NONE',
                                    eligible: false
                                }
                            ],
                            currentlyEnrolledInVeteransProgram: false,
                            hasNonESI: false
                        },
                        otherInsurance: {
                            insuranceName: 'kaiser',
                            policyNumber: 'A12343545',
                            limitedBenefit: true
                        },
                        formerEmployer: [
                            {
                                phone: {
                                    phoneExtension: '',
                                    phoneNumber: '',
                                    phoneType: 'CELL'
                                },
                                employerName: '',
                                employerIdentificationNumber: '',
                                employerContactPersonName: '',
                                address: {
                                    postalCode: '',
                                    county: null,
                                    primaryAddressCountyFipsCode: null,
                                    streetAddress1: '',
                                    streetAddress2: '',
                                    state: '',
                                    city: ''
                                },
                                employerContactPhone: {
                                    phoneExtension: '',
                                    phoneNumber: '',
                                    phoneType: 'HOME'
                                },
                                employerContactEmailAddress: ''
                            }
                        ],
                        primaryCarePhysicianName: '',
                        otherInsuranceIndicator: true,
                        currentlyEnrolledInCobraIndicator: null,
                        employerWillOfferInsuranceIndicator: true,
                        currentlyEnrolledInRetireePlanIndicator: null,
                        currentlyEnrolledInVeteransProgramIndicator: null,
                        hasPrimaryCarePhysicianIndicator: false,
                        employerWillOfferInsuranceCoverageStartDate: null,
                        willBeEnrolledInCobraIndicator: null,
                        willBeEnrolledInVeteransProgramIndicator: null,
                        medicaidInsurance: {
                            requestHelpPayingMedicalBillsLast3MonthsIndicator: false
                        },
                        isOfferedHealthCoverageThroughJobIndicator: null,
                        willBeEnrolledInRetireePlanIndicator: null,
                        employerWillOfferInsuranceStartDate: null,
                        stateHealthBenefit: null,
                        eligibleITU: null,
                        receivedITU: null,
                        unpaidBill: null,
                        coveredDependentChild: true,
                        absentParent: null
                    },
                    annualTaxIncome: {
                        reportedIncome: 3000000,
                        projectedIncome: 0,
                        incomeLessExplainedIndicator: null,
                        incomeExplanationRequiredIndicator: true,
                        unknownIncomeIndicator: null,
                        variableIncomeIndicator: null,
                        taxHouseholdIncomeDiscrepancyDescriptionText: null,
                        taxHouseholdIncomeDifferenceReasonType: [],
                        variableIncomeDescriptionText: null,
                        taxHouseholdIncomeDifferenceReason: 'OTHER'
                    },
                    inlineEligibility: {
                        preliminaryMedicaidStatus: 'YES',
                        preliminaryChipStatus: 'YES',
                        preliminaryEmergencyMedicaidStatus: 'YES',
                        preliminaryAptcCsrStatus: 'YES',
                        category: null,
                        categoryThreshold: null
                    },
                    medicaidChipDenial: null,
                    medicaidDeniedDate: null,
                    medicaidDeniedDueToImmigration: null,
                    changeInImmigrationSince5Year: null,
                    fiveYearBar: false,
                    changeInImmigrationSinceMedicaidDenial: null,
                    blindOrDisabled: false,
                    longTermCare: false,
                    disabilityIndicator: false,
                    hasESI: false,
                    incomes: [
                        {
                            amount: 770000,
                            frequency: 'MONTHLY',
                            sourceName: 'Air France',
                            type: 'JOB',
                            subType: 'UNSPECIFIED',
                            relatedExpense: null,
                            tribalAmount: null,
                            cyclesPerFrequency: null,
                            incomeExpectedForWholeYear: true,
                            incomeStartDate: null,
                            incomeEndDate: null,
                            incomeDifferenceReason: 'DECREASE_HOURS',
                            otherIncomeDifferenceReason: null,
                            jobIncomeExplanationRequiredIndicator: true
                        },
                        {
                            amount: 1500000,
                            frequency: 'YEARLY',
                            sourceName: 'Intel',
                            type: 'JOB',
                            subType: 'UNSPECIFIED',
                            relatedExpense: null,
                            tribalAmount: null,
                            incomeExpectedForWholeYear: true,
                            incomeStartDate: null,
                            incomeEndDate: null,
                            cyclesPerFrequency: null
                        }
                    ],
                    expenses: [
                        {
                            type: 'STUDENT_LOAN_INTEREST',
                            amount: 340000,
                            frequency: 'BIWEEKLY',
                            sourceName: '',
                            relatedExpense: 0,
                            subType: 'UNSPECIFIED',
                            incomeExpectedForWholeYear: true,
                            incomeStartDate: null,
                            incomeEndDate: null
                        },
                        {
                            type: 'ALIMONY',
                            amount: 110000,
                            frequency: 'MONTHLY',
                            sourceName: '',
                            relatedExpense: 0,
                            subType: 'UNSPECIFIED',
                            incomeExpectedForWholeYear: true,
                            incomeStartDate: null,
                            incomeEndDate: null
                        }
                    ],
                    detailedIncome: {
                        partnershipAndSwarpIncomeIncomeProof: '',
                        capitalGains: {
                            annualNetCapitalGains: null
                        },
                        unemploymentBenefit: {
                            incomeFrequency: '',
                            stateGovernmentName: '',
                            benefitAmount: null,
                            unemploymentDate: null
                        },
                        annuityIncomeProof: '',
                        scholarshipIncomeProof: '',
                        otherIncome: [
                            {
                                incomeFrequency: '',
                                incomeAmount: null,
                                otherIncomeTypeDescription: 'Canceled debts'
                            },
                            {
                                incomeFrequency: '',
                                incomeAmount: null,
                                otherIncomeTypeDescription: 'Court Awards'
                            },
                            {
                                incomeFrequency: '',
                                incomeAmount: null,
                                otherIncomeTypeDescription: 'Jury duty pay'
                            }
                        ],
                        receiveMAthrough1619: false,
                        taxExemptedIncomeProof: '',
                        wageIncomeProof: '',
                        dividendsIncomeProof: '',
                        farmFishingIncome: {
                            incomeFrequency: '',
                            netIncomeAmount: null
                        },
                        rentalRoyaltyIncomeIndicator: null,
                        unemploymentBenefitIndicator: null,
                        capitalGainsIndicator: null,
                        jobIncome: [
                            {
                                incomeFrequency: '',
                                employerName: '',
                                incomeAmountBeforeTaxes: null,
                                workHours: null
                            }
                        ],
                        alimonyReceivedIndicator: null,
                        unemploymentCompensationIncomeProof: '',
                        selfEmploymentTax: {
                            incomeAmount: null
                        },
                        studentLoanInterest: {
                            incomeAmount: null
                        },
                        selfEmploymentIncome: {
                            monthlyNetIncome: null,
                            typeOfWork: ''
                        },
                        businessIncomeProof: '',
                        sellingBusinessProperty: {
                            incomeAmount: null
                        },
                        retirementOrPension: {
                            taxableAmount: null,
                            incomeFrequency: ''
                        },
                        royaltiesIncomeProof: '',
                        farmFishingIncomeIndictor: null,
                        investmentIncome: {
                            incomeFrequency: '',
                            incomeAmount: null
                        },
                        farmIncom: {
                            incomeAmount: null
                        },
                        deductions: {
                            alimonyDeductionAmount: null,
                            otherDeductionAmount: null,
                            alimonyDeductionFrequency: '',
                            studentLoanDeductionFrequency: '',
                            deductionFrequency: 'MONTHLY',
                            studentLoanDeductionAmount: null,
                            deductionType: [
                                'ALIMONY',
                                'STUDENT_LOAN_INTEREST',
                                'OTHER'
                            ],
                            otherDeductionFrequency: '',
                            deductionAmount: null
                        },
                        rentalRoyaltyIncome: {
                            incomeFrequency: '',
                            netIncomeAmount: null
                        },
                        receiveMAthroughSSI: false,
                        foreignEarnedIncomeProof: '',
                        socialSecurityBenefit: {
                            incomeFrequency: '',
                            benefitAmount: null
                        },
                        foreignEarnedIncome: {
                            incomeAmount: null
                        },
                        childNaTribe: '',
                        sellingBusinessPropertyIncomeProof: '',
                        alimonyReceived: {
                            amountReceived: null,
                            incomeFrequency: ''
                        },
                        selfEmploymentTaxProof: '',
                        partnershipsCorporationsIncome: {
                            incomeAmount: null
                        },
                        studentLoanInterestProof: '',
                        farmIncomeProof: '',
                        retirementOrPensionIndicator: null,
                        investmentIncomeIndicator: null,
                        socialSecurityBenefitIndicator: null,
                        rentalRealEstateIncome: {
                            incomeAmount: null
                        },
                        otherIncomeIndicator: null,
                        pensionIncomeProof: '',
                        socialSecurityBenefitProof: '',
                        jobIncomeIndicator: null,
                        businessIncome: {
                            incomeAmount: null
                        },
                        taxableInterestIncomeProof: '',
                        selfEmploymentIncomeIndicator: null,
                        rentalRealEstateIncomeProof: '',
                        discrepancies: {
                            hasWageOrSalaryBeenCutIndicator: null,
                            explanationForJobIncomeDiscrepancy: '',
                            didPersonEverWorkForEmployerIndicator: null,
                            stopWorkingAtEmployerIndicator: null,
                            hasHoursDecreasedWithEmployerIndicator: null,
                            explanationForDependantDiscrepancy: '',
                            seasonalWorkerIndicator: null,
                            hasChangedJobsIndicator: false
                        }
                    },
                    dateOfBirth: '1950-01-25',
                    parentCaretakerRelatives: {
                        relationship: '',
                        dateOfBirth: null,
                        mainCaretakerOfChildIndicator: null,
                        name: {
                            middleName: '',
                            lastName: '',
                            firstName: '',
                            suffix: ''
                        },
                        liveWithAdoptiveParentsIndicator: true,
                        personId: [],
                        anotherChildIndicator: false
                    },
                    specialCircumstances: {
                        ageWhenLeftFosterCare: 19,
                        everInFosterCareIndicator: false,
                        metFosterCareConditions: false,
                        fosterChild: false,
                        numberBabiesExpectedInPregnancy: 0,
                        pregnantIndicator: false,
                        dueDateOfPregnancy: null,
                        gettingHealthCareThroughStateMedicaidIndicator: true,
                        fosterCareState: 'CA',
                        tribalManualVerificationIndicator: true,
                        americanIndianAlaskaNativeIndicator: true,
                        deceased: null,
                        deceasedDate: null
                    },
                    livesWithHouseholdContactIndicator: true,
                    socialSecurityCard: {
                        middleNameOnSSNCard: 'Johny',
                        deathManualVerificationIndicator: false,
                        socialSecurityNumber: '123456789',
                        suffixOnSSNCard: 'IV',
                        individualMandateExceptionIndicator: null,
                        ssnManualVerificationIndicator: true,
                        deathIndicatorAsAttested: false,
                        nameSameOnSSNCardIndicator: false,
                        deathIndicator: false,
                        firstNameOnSSNCard: 'Davido',
                        socialSecurityCardHolderIndicator: true,
                        useSelfAttestedDeathIndicator: true,
                        lastNameOnSSNCard: 'Blucksmith',
                        reasonableExplanationForNoSSN: 'JUST_APPLIED',
                        noSsnIssuedAttestation: null
                    },
                    strikerIndicator: false,
                    birthCertificateType: 'NO_CRETIFICATE',
                    citizenshipImmigrationStatus: {
                        honorablyDischargedOrActiveDutyMilitaryMemberIndicator: null,
                        citizenshipStatusIndicator: false,
                        eligibleImmigrationDocumentType: [
                            {
                                DS2019Indicator: false,
                                UnexpiredForeignPassportIndicator: false,
                                TemporaryI551StampIndicator: false,
                                I551Indicator: false,
                                MachineReadableVisaIndicator: false,
                                OtherDocumentTypeIndicator: false,
                                I94InPassportIndicator: false,
                                I571Indicator: false,
                                I766Indicator: true,
                                I20Indicator: false,
                                I94Indicator: false,
                                I797Indicator: false,
                                I327Indicator: false,
                                noneOfThese: false
                            }
                        ],
                        naturalizationCertificateIndicator: null,
                        citizenshipManualVerificationStatus: null,
                        citizenshipAsAttestedIndicator: null,
                        eligibleImmigrationStatusIndicator: null,
                        citizenshipDocument: {
                            foreignPassportOrDocumentNumber: null,
                            sevisId: null,
                            alienNumber: '987654328',
                            nameOnDocument: {
                                middleName: null,
                                lastName: null,
                                firstName: null,
                                suffix: null
                            },
                            documentDescription: null,
                            nameSameOnDocumentIndicator: null,
                            visaNumber: null,
                            documentExpirationDate: null,
                            i94Number: null,
                            foreignPassportCountryOfIssuance: null,
                            cardNumber: 'abs1234567890'
                        },
                        lawfulPresenceIndicator: true,
                        naturalizationCertificateAlienNumber: '',
                        eligibleImmigrationDocumentSelected: 'NaturalizationCertificate',
                        otherImmigrationDocumentType: {
                            cubanHaitianEntrantIndicator: false,
                            orreligibilityLetterIndicator: false,
                            stayOfRemovalIndicator: false,
                            orrcertificationIndicator: false,
                            americanSamoanIndicator: false,
                            withholdingOfRemovalIndicator: false,
                            domesticViolence: false,
                            indianOfUsOrCanada: false,
                            noneOfThese: false
                        },
                        naturalizedCitizenshipIndicator: true,
                        livedIntheUSSince1996Indicator: false,
                        naturalizationCertificateNaturalizationNumber: '',
                        unchangedImmigrationStatusLastFiveYears: null
                    },
                    medicalExpense: null,
                    specialEnrollmentPeriod: {
                        birthOrAdoptionEventIndicator: false
                    },
                    marriedIndicator: null,
                    bloodRelationship: [
                        {
                            individualPersonId: '1',
                            relatedPersonId: '1',
                            relation: '18',
                            personGuid: '1001002145',
                            relatedPersonGuid: '1001002145'
                        },
                        {
                            individualPersonId: '1',
                            relatedPersonId: '2',
                            relation: '01',
                            personGuid: '1001002145',
                            relatedPersonGuid: '1001016686'
                        },
                        {
                            individualPersonId: '2',
                            relatedPersonId: '1',
                            relation: '01',
                            personGuid: '1001016686',
                            relatedPersonGuid: '1001002145'
                        },
                        {
                            individualPersonId: '2',
                            relatedPersonId: '2',
                            relation: '18',
                            personGuid: '1001016686',
                            relatedPersonGuid: '1001016686'
                        },
                        {
                            individualPersonId: '1',
                            relatedPersonId: '3',
                            relation: '03',
                            personGuid: '1001002145',
                            relatedPersonGuid: '1001016687'
                        },
                        {
                            individualPersonId: '3',
                            relatedPersonId: '1',
                            relation: '19',
                            personGuid: '1001016687',
                            relatedPersonGuid: '1001002145'
                        },
                        {
                            individualPersonId: '2',
                            relatedPersonId: '3',
                            relation: '03',
                            personGuid: '1001016686',
                            relatedPersonGuid: '1001016687'
                        },
                        {
                            individualPersonId: '3',
                            relatedPersonId: '2',
                            relation: '19',
                            personGuid: '1001016687',
                            relatedPersonGuid: '1001016686'
                        },
                        {
                            individualPersonId: '3',
                            relatedPersonId: '3',
                            relation: '18',
                            personGuid: '1001016687',
                            relatedPersonGuid: '1001016687'
                        }
                    ],
                    drugFellowIndicator: false,
                    livingArrangementIndicator: false,
                    taxFiler: {
                        spouseHouseholdMemberId: 0,
                        claimingDependantsOnFTRIndicator: null,
                        taxFilerDependants: [
                            {
                                dependantHouseholdMemeberId: 0,
                                taxFilerDependantIndicator: false
                            }
                        ],
                        liveWithSpouseIndicator: null
                    },
                    shelterAndUtilityExpense: null,
                    tobaccoUserIndicator: false,
                    dependentCareExpense: null,
                    residencyVerificationIndicator: false,
                    taxFilerDependant: {
                        dependantHouseholdMemeberId: null,
                        taxFilerDependantIndicator: null
                    },
                    name: {
                        middleName: 'John',
                        lastName: 'Blacksmith',
                        firstName: 'David',
                        suffix: 'Jr.'
                    },
                    ethnicityAndRace: {
                        ethnicity: [
                            {
                                label: 'Cuban',
                                code: '2182-4',
                                otherLabel: null
                            },
                            {
                                label: 'Mexican, Mexican American, or Chicano/a',
                                code: '2148-5',
                                otherLabel: null
                            },
                            {
                                label: 'Puerto Rican',
                                code: '2180-8',
                                otherLabel: null
                            },
                            {
                                label: 'Brasilian',
                                code: '0000-0',
                                otherLabel: null
                            }
                        ],
                        race: [
                            {
                                label: 'American Indian or Alaska Native',
                                code: '1002-5',
                                otherLabel: null
                            },
                            {
                                label: 'Samoan',
                                code: '2080-0',
                                otherLabel: null
                            },
                            {
                                label: 'Vietnamese',
                                code: '2047-9',
                                otherLabel: null
                            },
                            {
                                label: 'Georgian',
                                code: '2131-1',
                                otherLabel: null
                            }
                        ],
                        hispanicLatinoSpanishOriginIndicator: true
                    },
                    personId: 1,
                    addressId: 1,
                    householdId: 0,
                    gender: 'male',
                    SSIIndicator: false,
                    IPVIndicator: false,
                    householdContactIndicator: true,
                    americanIndianAlaskaNative: {
                        tribeName: 'AL010001',
                        tribeFullName: null,
                        state: 'AL',
                        stateFullName: null,
                        memberOfFederallyRecognizedTribeIndicator: true,
                        americanIndianAlaskaNativeSelfIdentification: true
                    },
                    householdContact: {
                        homeAddressIndicator: true,
                        phone: {
                            phoneExtension: null,
                            phoneNumber: '1232321234',
                            phoneType: null
                        },
                        homeAddress: {
                            addressId: 1,
                            postalCode: '83406',
                            countyCode: '16019',
                            county: 'Bonneville',
                            primaryAddressCountyFipsCode: '16019',
                            streetAddress1: '6430 E Mansion Hill Dr',
                            streetAddress2: 'apt. 12',
                            state: 'ID',
                            city: 'Ammon'
                        },
                        stateResidencyProof: '',
                        otherPhone: {
                            phoneExtension: '1223',
                            phoneNumber: '4087995678',
                            phoneType: null
                        },
                        contactPreferences: {
                            emailAddress: 'davidblacksmth@gmail.com',
                            preferredSpokenLanguage: 'English',
                            preferredContactMethod: 'Email',
                            preferredWrittenLanguage: 'English',
                            textMe: false,
                            paperless1095: true,
                            emailMe: true
                        },
                        mailingAddress: {
                            postalCode: '83338',
                            countyCode: '16047',
                            county: 'Gooding',
                            primaryAddressCountyFipsCode: '16047',
                            streetAddress1: '1410 N Lincoln Ave',
                            streetAddress2: 'apt. 1',
                            state: 'ID',
                            city: 'Jerome'
                        },
                        mailingAddressSameAsHomeAddressIndicator: null,
                        outOfStateAttestation: true
                    },
                    PIDVerificationIndicator: false,
                    applicantGuid: '1001002145',
                    PIDIndicator: false,
                    applyingForCoverageIndicator: null,
                    planToFileFTRJointlyIndicator: null,
                    livesAtOtherAddressIndicator: null,
                    planToFileFTRIndicator: null,
                    otherAddress: {
                        address: {
                            postalCode: '75123',
                            county: '',
                            countyCode: 'Santa Clara',
                            primaryAddressCountyFipsCode: null,
                            streetAddress1: '',
                            streetAddress2: '',
                            state: 'CA',
                            city: ''
                        },
                        livingOutsideofStateTemporarilyAddress: {
                            postalCode: '',
                            county: '',
                            primaryAddressCountyFipsCode: null,
                            streetAddress1: '',
                            streetAddress2: '',
                            state: '',
                            city: ''
                        },
                        livingOutsideofStateTemporarilyIndicator: null
                    },
                    heatingCoolingindicator: false,
                    incarcerationStatus: {
                        incarcerationManualVerificationIndicator: false,
                        incarcerationStatusIndicator: false,
                        useSelfAttestedIncarceration: false,
                        incarcerationPendingDispositionIndicator: false,
                        incarcerationAsAttestedIndicator: false
                    },
                    infantIndicator: false,
                    childSupportExpense: null,
                    expeditedIncome: {
                        irsReportedAnnualIncome: null,
                        expectedAnnualIncomeUnknownIndicator: null,
                        irsIncomeManualVerificationIndicator: false,
                        expectedAnnualIncome: null
                    },
                    migrantFarmWorker: true,
                    status: 'ADD_NEW',
                    mediciadChipDenial: true,
                    under26Indicator: true,
                    externalId: null
                },
                {
                    healthReimbursementArrangement: [],
                    seeksQhp: true,
                    applicantPersonType: 'DEP',
                    flagBucket: {
                        taxHouseholdCompositionFlags: 604587154,
                        taxHouseholdCompositionProgressFlags: 21650,
                        annualTaxIncomeFlags: 18
                    },
                    taxHouseholdComposition: {
                        married: null,
                        taxFiler: null,
                        claimingDependents: null,
                        taxDependent: null,
                        claimedOutsideHousehold: false,
                        spouseMatch: null,
                        livesWithSpouse: null,
                        taxFilingStatus: 'FILING_JOINTLY',
                        taxRelationship: 'SPOUSE',
                        claimerIds: [],
                        independentTaxFiler: false
                    },
                    parentCaretaker: null,
                    fullTimeStudent: null,
                    employerSponsoredCoverage: [
                        {
                            companyName: 'Intel',
                            applicantGuid: '1001016686',
                            memberName: 'Sarah Jessica Blacksmith III',
                            name: {
                                firstName: 'Joan',
                                middleName: 'Miranda',
                                lastName: 'Johnson',
                                suffix: 'IV'
                            },
                            phone: '3333333333',
                            email: 'joan_12@intel.com',
                            address: {
                                postalCode: '95136',
                                county: null,
                                streetAddress1: '15th street',
                                streetAddress2: 'suit 11',
                                state: 'CA',
                                city: 'San Jose'
                            },
                            ein: '4567890',
                            minimumValuePlan: true,
                            employerPremium: 400000,
                            employerPremiumFrequency: 'QUARTERLY',
                            employerOfferAffordable: false,
                            escOfferType: 'SelfOnlyCoverage'
                        },
                        {
                            companyName: 'Air France',
                            applicantGuid: '1001002145',
                            memberName: 'David John Blacksmith Jr.',
                            name: {
                                firstName: 'Mike',
                                middleName: 'Daniel',
                                lastName: 'Hunter',
                                suffix: 'III'
                            },
                            phone: '2222222222',
                            email: 'mike_hunter@airfrance.com',
                            address: {
                                postalCode: '95136',
                                county: null,
                                streetAddress1: '1st street',
                                streetAddress2: 'suit 200',
                                state: 'CA',
                                city: 'San Jose'
                            },
                            ein: '1234567',
                            minimumValuePlan: true,
                            employerPremium: 20000,
                            employerPremiumFrequency: 'BIMONTHLY',
                            employerOfferAffordable: false,
                            escOfferType: 'FamilyCoverage'
                        }
                    ],
                    annualTaxIncome: {
                        reportedIncome: 0,
                        projectedIncome: 0
                    },
                    inlineEligibility: {
                        preliminaryMedicaidStatus: 'YES',
                        preliminaryChipStatus: 'YES',
                        preliminaryEmergencyMedicaidStatus: 'YES',
                        preliminaryAptcCsrStatus: 'YES',
                        category: null,
                        categoryThreshold: null
                    },
                    medicaidChipDenial: null,
                    medicaidDeniedDate: null,
                    medicaidDeniedDueToImmigration: null,
                    changeInImmigrationSince5Year: null,
                    fiveYearBar: null,
                    changeInImmigrationSinceMedicaidDenial: null,
                    blindOrDisabled: false,
                    longTermCare: false,
                    disabilityIndicator: false,
                    hasESI: false,
                    incomes: [
                        {
                            amount: 920000,
                            frequency: 'MONTHLY',
                            sourceName: 'Intel',
                            type: 'JOB',
                            subType: 'UNSPECIFIED',
                            relatedExpense: null,
                            tribalAmount: null,
                            incomeExpectedForWholeYear: true,
                            incomeStartDate: null,
                            incomeEndDate: null,
                            cyclesPerFrequency: null,
                            incomeDifferenceReason: 'WAGE_CUT',
                            otherIncomeDifferenceReason: null,
                            jobIncomeExplanationRequiredIndicator: true
                        }
                    ],
                    expenses: [],
                    detailedIncome: {
                        partnershipAndSwarpIncomeIncomeProof: '',
                        capitalGains: {
                            annualNetCapitalGains: null
                        },
                        unemploymentBenefit: {
                            incomeFrequency: '',
                            stateGovernmentName: '',
                            benefitAmount: null,
                            unemploymentDate: null
                        },
                        annuityIncomeProof: '',
                        scholarshipIncomeProof: '',
                        otherIncome: [
                            {
                                incomeFrequency: '',
                                incomeAmount: null,
                                otherIncomeTypeDescription: 'Canceled debts'
                            },
                            {
                                incomeFrequency: '',
                                incomeAmount: null,
                                otherIncomeTypeDescription: 'Court Awards'
                            },
                            {
                                incomeFrequency: '',
                                incomeAmount: null,
                                otherIncomeTypeDescription: 'Jury duty pay'
                            }
                        ],
                        receiveMAthrough1619: false,
                        taxExemptedIncomeProof: '',
                        wageIncomeProof: '',
                        dividendsIncomeProof: '',
                        farmFishingIncome: {
                            incomeFrequency: '',
                            netIncomeAmount: null
                        },
                        rentalRoyaltyIncomeIndicator: null,
                        unemploymentBenefitIndicator: null,
                        capitalGainsIndicator: null,
                        jobIncome: [
                            {
                                incomeFrequency: '',
                                employerName: '',
                                incomeAmountBeforeTaxes: null,
                                workHours: null
                            }
                        ],
                        alimonyReceivedIndicator: null,
                        unemploymentCompensationIncomeProof: '',
                        selfEmploymentTax: {
                            incomeAmount: null
                        },
                        studentLoanInterest: {
                            incomeAmount: null
                        },
                        selfEmploymentIncome: {
                            monthlyNetIncome: null,
                            typeOfWork: ''
                        },
                        businessIncomeProof: '',
                        sellingBusinessProperty: {
                            incomeAmount: null
                        },
                        retirementOrPension: {
                            taxableAmount: null,
                            incomeFrequency: ''
                        },
                        royaltiesIncomeProof: '',
                        farmFishingIncomeIndictor: null,
                        investmentIncome: {
                            incomeFrequency: '',
                            incomeAmount: null
                        },
                        farmIncom: {
                            incomeAmount: null
                        },
                        deductions: {
                            alimonyDeductionAmount: null,
                            otherDeductionAmount: null,
                            alimonyDeductionFrequency: '',
                            studentLoanDeductionFrequency: '',
                            deductionFrequency: 'MONTHLY',
                            studentLoanDeductionAmount: null,
                            deductionType: [
                                'ALIMONY',
                                'STUDENT_LOAN_INTEREST',
                                'OTHER'
                            ],
                            otherDeductionFrequency: '',
                            deductionAmount: null
                        },
                        rentalRoyaltyIncome: {
                            incomeFrequency: '',
                            netIncomeAmount: null
                        },
                        receiveMAthroughSSI: false,
                        foreignEarnedIncomeProof: '',
                        socialSecurityBenefit: {
                            incomeFrequency: '',
                            benefitAmount: null
                        },
                        foreignEarnedIncome: {
                            incomeAmount: null
                        },
                        childNaTribe: '',
                        sellingBusinessPropertyIncomeProof: '',
                        alimonyReceived: {
                            amountReceived: null,
                            incomeFrequency: ''
                        },
                        selfEmploymentTaxProof: '',
                        partnershipsCorporationsIncome: {
                            incomeAmount: null
                        },
                        studentLoanInterestProof: '',
                        farmIncomeProof: '',
                        retirementOrPensionIndicator: null,
                        investmentIncomeIndicator: null,
                        socialSecurityBenefitIndicator: null,
                        rentalRealEstateIncome: {
                            incomeAmount: null
                        },
                        otherIncomeIndicator: null,
                        pensionIncomeProof: '',
                        socialSecurityBenefitProof: '',
                        jobIncomeIndicator: null,
                        businessIncome: {
                            incomeAmount: null
                        },
                        taxableInterestIncomeProof: '',
                        selfEmploymentIncomeIndicator: null,
                        rentalRealEstateIncomeProof: '',
                        discrepancies: {
                            hasWageOrSalaryBeenCutIndicator: null,
                            explanationForJobIncomeDiscrepancy: '',
                            didPersonEverWorkForEmployerIndicator: null,
                            stopWorkingAtEmployerIndicator: null,
                            hasHoursDecreasedWithEmployerIndicator: null,
                            explanationForDependantDiscrepancy: '',
                            seasonalWorkerIndicator: null,
                            hasChangedJobsIndicator: false
                        }
                    },
                    dateOfBirth: '2000-09-23',
                    parentCaretakerRelatives: {
                        relationship: '',
                        dateOfBirth: null,
                        mainCaretakerOfChildIndicator: null,
                        name: {
                            middleName: '',
                            lastName: '',
                            firstName: '',
                            suffix: ''
                        },
                        liveWithAdoptiveParentsIndicator: true,
                        personId: [],
                        anotherChildIndicator: false
                    },
                    specialCircumstances: {
                        ageWhenLeftFosterCare: 4,
                        everInFosterCareIndicator: false,
                        metFosterCareConditions: false,
                        fosterChild: false,
                        numberBabiesExpectedInPregnancy: 7,
                        pregnantIndicator: true,
                        dueDateOfPregnancy: '2022-01-01',
                        gettingHealthCareThroughStateMedicaidIndicator: true,
                        fosterCareState: 'NJ',
                        tribalManualVerificationIndicator: true,
                        americanIndianAlaskaNativeIndicator: true,
                        deceased: null,
                        deceasedDate: null
                    },
                    livesWithHouseholdContactIndicator: true,
                    socialSecurityCard: {
                        middleNameOnSSNCard: '',
                        deathManualVerificationIndicator: false,
                        socialSecurityNumber: '444332222',
                        suffixOnSSNCard: '',
                        individualMandateExceptionIndicator: null,
                        ssnManualVerificationIndicator: true,
                        deathIndicatorAsAttested: false,
                        nameSameOnSSNCardIndicator: null,
                        deathIndicator: false,
                        firstNameOnSSNCard: '',
                        socialSecurityCardHolderIndicator: false,
                        useSelfAttestedDeathIndicator: true,
                        lastNameOnSSNCard: '',
                        reasonableExplanationForNoSSN: 'RELIGIOUS_EXCEPTION',
                        noSsnIssuedAttestation: null
                    },
                    strikerIndicator: false,
                    birthCertificateType: 'NO_CRETIFICATE',
                    citizenshipImmigrationStatus: {
                        honorablyDischargedOrActiveDutyMilitaryMemberIndicator: null,
                        citizenshipStatusIndicator: false,
                        eligibleImmigrationDocumentType: [
                            {
                                DS2019Indicator: false,
                                UnexpiredForeignPassportIndicator: false,
                                TemporaryI551StampIndicator: false,
                                I551Indicator: false,
                                MachineReadableVisaIndicator: false,
                                OtherDocumentTypeIndicator: false,
                                I94InPassportIndicator: false,
                                I571Indicator: false,
                                I766Indicator: true,
                                I20Indicator: false,
                                I94Indicator: false,
                                I797Indicator: false,
                                I327Indicator: false,
                                noneOfThese: false
                            }
                        ],
                        naturalizationCertificateIndicator: null,
                        citizenshipManualVerificationStatus: null,
                        citizenshipAsAttestedIndicator: false,
                        eligibleImmigrationStatusIndicator: false,
                        citizenshipDocument: {
                            foreignPassportOrDocumentNumber: '',
                            sevisId: '',
                            alienNumber: '3673736',
                            nameOnDocument: {
                                middleName: '',
                                lastName: '',
                                firstName: '',
                                suffix: ''
                            },
                            documentDescription: '',
                            nameSameOnDocumentIndicator: null,
                            visaNumber: '',
                            documentExpirationDate: null,
                            i94Number: '',
                            foreignPassportCountryOfIssuance: '0',
                            cardNumber: ''
                        },
                        lawfulPresenceIndicator: true,
                        naturalizationCertificateAlienNumber: '',
                        eligibleImmigrationDocumentSelected: 'NaturalizationCertificate',
                        otherImmigrationDocumentType: {
                            cubanHaitianEntrantIndicator: false,
                            orreligibilityLetterIndicator: false,
                            stayOfRemovalIndicator: false,
                            orrcertificationIndicator: false,
                            americanSamoanIndicator: false,
                            withholdingOfRemovalIndicator: false,
                            domesticViolence: false,
                            indianOfUsOrCanada: false,
                            noneOfThese: false
                        },
                        naturalizedCitizenshipIndicator: true,
                        livedIntheUSSince1996Indicator: false,
                        naturalizationCertificateNaturalizationNumber: ''
                    },
                    medicalExpense: null,
                    specialEnrollmentPeriod: {
                        birthOrAdoptionEventIndicator: false
                    },
                    marriedIndicator: null,
                    bloodRelationship: [],
                    drugFellowIndicator: false,
                    livingArrangementIndicator: false,
                    taxFiler: {
                        spouseHouseholdMemberId: 0,
                        claimingDependantsOnFTRIndicator: null,
                        taxFilerDependants: [
                            {
                                dependantHouseholdMemeberId: 0,
                                taxFilerDependantIndicator: false
                            }
                        ],
                        liveWithSpouseIndicator: null
                    },
                    shelterAndUtilityExpense: null,
                    tobaccoUserIndicator: false,
                    dependentCareExpense: null,
                    residencyVerificationIndicator: false,
                    taxFilerDependant: {
                        dependantHouseholdMemeberId: null,
                        taxFilerDependantIndicator: null
                    },
                    name: {
                        middleName: 'Jessica',
                        lastName: 'Blacksmith',
                        firstName: 'Sarah',
                        suffix: 'III'
                    },
                    ethnicityAndRace: {
                        ethnicity: [],
                        race: [
                            {
                                label: 'American Indian or Alaska Native',
                                code: '1002-5',
                                otherLabel: null
                            },
                            {
                                label: 'Asian Indian',
                                code: '2029-7',
                                otherLabel: null
                            },
                            {
                                label: 'Black or African American',
                                code: '2054-5',
                                otherLabel: null
                            },
                            {
                                label: 'Other Pacific Islander',
                                code: '2500-7',
                                otherLabel: null
                            }
                        ],
                        hispanicLatinoSpanishOriginIndicator: false
                    },
                    personId: 2,
                    addressId: 1,
                    householdId: 0,
                    gender: 'female',
                    SSIIndicator: false,
                    IPVIndicator: false,
                    householdContactIndicator: true,
                    americanIndianAlaskaNative: {
                        tribeName: null,
                        tribeFullName: null,
                        state: null,
                        stateFullName: null,
                        memberOfFederallyRecognizedTribeIndicator: false,
                        americanIndianAlaskaNativeSelfIdentification: false
                    },
                    householdContact: {
                        homeAddressIndicator: false,
                        phone: {
                            phoneExtension: '',
                            phoneNumber: '',
                            phoneType: 'CELL'
                        },
                        homeAddress: {
                            postalCode: '',
                            countyCode: null,
                            county: '',
                            primaryAddressCountyFipsCode: '',
                            streetAddress1: '',
                            streetAddress2: '',
                            state: '',
                            city: ''
                        },
                        stateResidencyProof: '',
                        otherPhone: {
                            phoneExtension: '',
                            phoneNumber: '',
                            phoneType: 'HOME'
                        },
                        contactPreferences: {
                            emailAddress: '',
                            preferredSpokenLanguage: '',
                            preferredContactMethod: '',
                            preferredWrittenLanguage: ''
                        },
                        mailingAddress: {
                            postalCode: '',
                            countyCode: null,
                            county: '',
                            primaryAddressCountyFipsCode: null,
                            streetAddress1: '',
                            streetAddress2: '',
                            state: '',
                            city: ''
                        },
                        mailingAddressSameAsHomeAddressIndicator: true
                    },
                    PIDVerificationIndicator: false,
                    applicantGuid: '1001016686',
                    PIDIndicator: false,
                    applyingForCoverageIndicator: true,
                    planToFileFTRJontlyIndicator: null,
                    livesAtOtherAddressIndicator: null,
                    healthCoverage: {
                        chpInsurance: {
                            reasonInsuranceEndedOther: '',
                            insuranceEndedDuringWaitingPeriodIndicator: false
                        },
                        haveBeenUninsuredInLast6MonthsIndicator: null,
                        currentEmployer: [
                            {
                                employer: {
                                    phone: {
                                        phoneExtension: '',
                                        phoneNumber: '',
                                        phoneType: 'HOME'
                                    },
                                    employerContactPersonName: '',
                                    employerContactEmailAddress: ''
                                },
                                currentEmployerInsurance: {
                                    currentLowestCostSelfOnlyPlanName: '',
                                    willBeEnrolledInEmployerPlanIndicator: false,
                                    memberEmployerPlanStartDate: null,
                                    willBeEnrolledInEmployerPlanDate: null,
                                    comingPlanMeetsMinimumStandardIndicator: false,
                                    memberPlansToDropEmployerPlanIndicator: true,
                                    employerWillOfferPlanIndicator: true,
                                    expectedChangesToEmployerCoverageIndicator: true,
                                    employerCoverageEndingDate: null,
                                    memberPlansToEnrollInEmployerPlanIndicator: true,
                                    employerPlanStartDate: null,
                                    memberEmployerPlanEndingDate: null,
                                    comingLowestCostSelfOnlyPlanName: '',
                                    currentPlanMeetsMinimumStandardIndicator: false,
                                    employerWillNotOfferCoverageIndicator: false,
                                    isCurrentlyEnrolledInEmployerPlanIndicator: false,
                                    insuranceName: null,
                                    policyNumber: null
                                }
                            }
                        ],
                        currentlyHasHealthInsuranceIndicator: false,
                        currentOtherInsurance: {
                            otherStateOrFederalMedicaidProgramName: 'Medicaid',
                            otherStateOrFederalCHIPProgramName: 'Nevada Check Up',
                            otherStateOrFederalPrograms: [],
                            currentlyEnrolledInVeteransProgram: false,
                            hasNonESI: false
                        },
                        otherInsurance: {
                            insuranceName: '',
                            policyNumber: '',
                            limitedBenefit: false
                        },
                        formerEmployer: [
                            {
                                phone: {
                                    phoneExtension: '',
                                    phoneNumber: '',
                                    phoneType: 'CELL'
                                },
                                employerName: '',
                                employerIdentificationNumber: '',
                                employerContactPersonName: '',
                                address: {
                                    postalCode: '',
                                    county: null,
                                    primaryAddressCountyFipsCode: null,
                                    streetAddress1: '',
                                    streetAddress2: '',
                                    state: '',
                                    city: ''
                                },
                                employerContactPhone: {
                                    phoneExtension: '',
                                    phoneNumber: '',
                                    phoneType: 'HOME'
                                },
                                employerContactEmailAddress: ''
                            }
                        ],
                        primaryCarePhysicianName: '',
                        otherInsuranceIndicator: true,
                        currentlyEnrolledInCobraIndicator: null,
                        employerWillOfferInsuranceIndicator: true,
                        currentlyEnrolledInRetireePlanIndicator: null,
                        currentlyEnrolledInVeteransProgramIndicator: null,
                        hasPrimaryCarePhysicianIndicator: false,
                        employerWillOfferInsuranceCoverageStartDate: null,
                        willBeEnrolledInCobraIndicator: null,
                        willBeEnrolledInVeteransProgramIndicator: null,
                        medicaidInsurance: {
                            requestHelpPayingMedicalBillsLast3MonthsIndicator: false
                        },
                        isOfferedHealthCoverageThroughJobIndicator: null,
                        willBeEnrolledInRetireePlanIndicator: null,
                        employerWillOfferInsuranceStartDate: null,
                        stateHealthBenefit: null,
                        eligibleITU: null,
                        receivedITU: null,
                        unpaidBill: null,
                        coveredDependentChild: null,
                        absentParent: null
                    },
                    planToFileFTRIndicator: null,
                    otherAddress: {
                        address: {
                            postalCode: '95136',
                            county: '06085',
                            countyCode: 'Santa Clara',
                            primaryAddressCountyFipsCode: null,
                            streetAddress1: '4300 The Woods Drive',
                            streetAddress2: 'Apt. 1808',
                            state: 'NV',
                            city: 'San Jose'
                        },
                        livingOutsideofStateTemporarilyAddress: {
                            postalCode: '94188',
                            county: '',
                            primaryAddressCountyFipsCode: null,
                            streetAddress1: '',
                            streetAddress2: '',
                            state: 'CA',
                            city: 'Sunnyvale'
                        },
                        livingOutsideofStateTemporarilyIndicator: true
                    },
                    heatingCoolingindicator: false,
                    incarcerationStatus: {
                        incarcerationManualVerificationIndicator: false,
                        incarcerationStatusIndicator: false,
                        useSelfAttestedIncarceration: false,
                        incarcerationPendingDispositionIndicator: false,
                        incarcerationAsAttestedIndicator: false
                    },
                    infantIndicator: false,
                    childSupportExpense: null,
                    expeditedIncome: {
                        irsReportedAnnualIncome: null,
                        expectedAnnualIncomeUnknownIndicator: null,
                        irsIncomeManualVerificationIndicator: false,
                        expectedAnnualIncome: null
                    },
                    migrantFarmWorker: true,
                    status: 'ADD_NEW',
                    mediciadChipDenial: false,
                    under26Indicator: true,
                    externalId: null
                },
                {
                    healthReimbursementArrangement: [],
                    seeksQhp: true,
                    applicantPersonType: 'DEP',
                    flagBucket: {
                        taxHouseholdCompositionFlags: 604587154,
                        taxHouseholdCompositionProgressFlags: 21650,
                        annualTaxIncomeFlags: 18
                    },
                    employerSponsoredCoverage: [],
                    taxHouseholdComposition: {
                        married: null,
                        taxFiler: null,
                        claimingDependents: null,
                        taxDependent: null,
                        claimedOutsideHousehold: false,
                        spouseMatch: null,
                        livesWithSpouse: null,
                        taxFilingStatus: 'UNSPECIFIED',
                        taxRelationship: 'UNSPECIFIED',
                        claimerIds: [],
                        independentTaxFiler: false
                    },
                    parentCaretaker: null,
                    fullTimeStudent: null,
                    annualTaxIncome: {
                        reportedIncome: 0,
                        projectedIncome: 0
                    },
                    inlineEligibility: {
                        preliminaryMedicaidStatus: 'YES',
                        preliminaryChipStatus: 'YES',
                        preliminaryEmergencyMedicaidStatus: 'YES',
                        preliminaryAptcCsrStatus: 'YES',
                        category: null,
                        categoryThreshold: null
                    },
                    medicaidChipDenial: null,
                    medicaidDeniedDate: null,
                    medicaidDeniedDueToImmigration: null,
                    changeInImmigrationSince5Year: null,
                    fiveYearBar: null,
                    changeInImmigrationSinceMedicaidDenial: null,
                    blindOrDisabled: false,
                    longTermCare: false,
                    disabilityIndicator: false,
                    hasESI: false,
                    incomes: [],
                    expenses: [],
                    detailedIncome: {
                        partnershipAndSwarpIncomeIncomeProof: '',
                        capitalGains: {
                            annualNetCapitalGains: null
                        },
                        unemploymentBenefit: {
                            incomeFrequency: '',
                            stateGovernmentName: '',
                            benefitAmount: null,
                            unemploymentDate: null
                        },
                        annuityIncomeProof: '',
                        scholarshipIncomeProof: '',
                        otherIncome: [
                            {
                                incomeFrequency: '',
                                incomeAmount: null,
                                otherIncomeTypeDescription: 'Canceled debts'
                            },
                            {
                                incomeFrequency: '',
                                incomeAmount: null,
                                otherIncomeTypeDescription: 'Court Awards'
                            },
                            {
                                incomeFrequency: '',
                                incomeAmount: null,
                                otherIncomeTypeDescription: 'Jury duty pay'
                            }
                        ],
                        receiveMAthrough1619: false,
                        taxExemptedIncomeProof: '',
                        wageIncomeProof: '',
                        dividendsIncomeProof: '',
                        farmFishingIncome: {
                            incomeFrequency: '',
                            netIncomeAmount: null
                        },
                        rentalRoyaltyIncomeIndicator: null,
                        unemploymentBenefitIndicator: null,
                        capitalGainsIndicator: null,
                        jobIncome: [
                            {
                                incomeFrequency: '',
                                employerName: '',
                                incomeAmountBeforeTaxes: null,
                                workHours: null
                            }
                        ],
                        alimonyReceivedIndicator: null,
                        unemploymentCompensationIncomeProof: '',
                        selfEmploymentTax: {
                            incomeAmount: null
                        },
                        studentLoanInterest: {
                            incomeAmount: null
                        },
                        selfEmploymentIncome: {
                            monthlyNetIncome: null,
                            typeOfWork: ''
                        },
                        businessIncomeProof: '',
                        sellingBusinessProperty: {
                            incomeAmount: null
                        },
                        retirementOrPension: {
                            taxableAmount: null,
                            incomeFrequency: ''
                        },
                        royaltiesIncomeProof: '',
                        farmFishingIncomeIndictor: null,
                        investmentIncome: {
                            incomeFrequency: '',
                            incomeAmount: null
                        },
                        farmIncom: {
                            incomeAmount: null
                        },
                        deductions: {
                            alimonyDeductionAmount: null,
                            otherDeductionAmount: null,
                            alimonyDeductionFrequency: '',
                            studentLoanDeductionFrequency: '',
                            deductionFrequency: 'MONTHLY',
                            studentLoanDeductionAmount: null,
                            deductionType: [
                                'ALIMONY',
                                'STUDENT_LOAN_INTEREST',
                                'OTHER'
                            ],
                            otherDeductionFrequency: '',
                            deductionAmount: null
                        },
                        rentalRoyaltyIncome: {
                            incomeFrequency: '',
                            netIncomeAmount: null
                        },
                        receiveMAthroughSSI: false,
                        foreignEarnedIncomeProof: '',
                        socialSecurityBenefit: {
                            incomeFrequency: '',
                            benefitAmount: null
                        },
                        foreignEarnedIncome: {
                            incomeAmount: null
                        },
                        childNaTribe: '',
                        sellingBusinessPropertyIncomeProof: '',
                        alimonyReceived: {
                            amountReceived: null,
                            incomeFrequency: ''
                        },
                        selfEmploymentTaxProof: '',
                        partnershipsCorporationsIncome: {
                            incomeAmount: null
                        },
                        studentLoanInterestProof: '',
                        farmIncomeProof: '',
                        retirementOrPensionIndicator: null,
                        investmentIncomeIndicator: null,
                        socialSecurityBenefitIndicator: null,
                        rentalRealEstateIncome: {
                            incomeAmount: null
                        },
                        otherIncomeIndicator: null,
                        pensionIncomeProof: '',
                        socialSecurityBenefitProof: '',
                        jobIncomeIndicator: null,
                        businessIncome: {
                            incomeAmount: null
                        },
                        taxableInterestIncomeProof: '',
                        selfEmploymentIncomeIndicator: null,
                        rentalRealEstateIncomeProof: '',
                        discrepancies: {
                            hasWageOrSalaryBeenCutIndicator: null,
                            explanationForJobIncomeDiscrepancy: '',
                            didPersonEverWorkForEmployerIndicator: null,
                            stopWorkingAtEmployerIndicator: null,
                            hasHoursDecreasedWithEmployerIndicator: null,
                            explanationForDependantDiscrepancy: '',
                            seasonalWorkerIndicator: null,
                            hasChangedJobsIndicator: false
                        }
                    },
                    dateOfBirth: '2010-09-22',
                    parentCaretakerRelatives: {
                        relationship: '',
                        dateOfBirth: null,
                        mainCaretakerOfChildIndicator: null,
                        name: {
                            middleName: '',
                            lastName: '',
                            firstName: '',
                            suffix: ''
                        },
                        liveWithAdoptiveParentsIndicator: true,
                        personId: [],
                        anotherChildIndicator: false
                    },
                    specialCircumstances: {
                        ageWhenLeftFosterCare: 0,
                        everInFosterCareIndicator: false,
                        metFosterCareConditions: false,
                        fosterChild: false,
                        numberBabiesExpectedInPregnancy: 0,
                        pregnantIndicator: false,
                        dueDateOfPregnancy: null,
                        gettingHealthCareThroughStateMedicaidIndicator: true,
                        tribalManualVerificationIndicator: true,
                        fosterCareState: 'NJ',
                        americanIndianAlaskaNativeIndicator: true,
                        deceased: null,
                        deceasedDate: null
                    },
                    livesWithHouseholdContactIndicator: true,
                    socialSecurityCard: {
                        middleNameOnSSNCard: '',
                        deathManualVerificationIndicator: false,
                        socialSecurityNumber: null,
                        suffixOnSSNCard: '',
                        individualMandateExceptionIndicator: null,
                        ssnManualVerificationIndicator: true,
                        deathIndicatorAsAttested: false,
                        nameSameOnSSNCardIndicator: null,
                        deathIndicator: false,
                        firstNameOnSSNCard: '',
                        socialSecurityCardHolderIndicator: false,
                        useSelfAttestedDeathIndicator: true,
                        lastNameOnSSNCard: '',
                        reasonableExplanationForNoSSN: 'JUST_APPLIED',
                        noSsnIssuedAttestation: null
                    },
                    strikerIndicator: false,
                    birthCertificateType: 'NO_CRETIFICATE',
                    citizenshipImmigrationStatus: {
                        honorablyDischargedOrActiveDutyMilitaryMemberIndicator: null,
                        citizenshipStatusIndicator: null,
                        eligibleImmigrationDocumentType: [
                            {
                                DS2019Indicator: false,
                                UnexpiredForeignPassportIndicator: false,
                                TemporaryI551StampIndicator: false,
                                I551Indicator: false,
                                MachineReadableVisaIndicator: false,
                                OtherDocumentTypeIndicator: false,
                                I94InPassportIndicator: false,
                                I571Indicator: false,
                                I766Indicator: true,
                                I20Indicator: false,
                                I94Indicator: false,
                                I797Indicator: false,
                                I327Indicator: false,
                                noneOfThese: false
                            }
                        ],
                        naturalizationCertificateIndicator: null,
                        citizenshipManualVerificationStatus: null,
                        citizenshipAsAttestedIndicator: false,
                        eligibleImmigrationStatusIndicator: false,
                        citizenshipDocument: {
                            foreignPassportOrDocumentNumber: '',
                            sevisId: '',
                            alienNumber: '43737778',
                            nameOnDocument: {
                                middleName: '',
                                lastName: '',
                                firstName: '',
                                suffix: ''
                            },
                            documentDescription: '',
                            nameSameOnDocumentIndicator: null,
                            visaNumber: '',
                            documentExpirationDate: null,
                            i94Number: '',
                            foreignPassportCountryOfIssuance: '0',
                            cardNumber: ''
                        },
                        lawfulPresenceIndicator: true,
                        naturalizationCertificateAlienNumber: '',
                        eligibleImmigrationDocumentSelected: 'CitizenshipCertificate',
                        otherImmigrationDocumentType: {
                            cubanHaitianEntrantIndicator: false,
                            orreligibilityLetterIndicator: false,
                            stayOfRemovalIndicator: false,
                            orrcertificationIndicator: false,
                            americanSamoanIndicator: false,
                            withholdingOfRemovalIndicator: false,
                            domesticViolence: false,
                            indianOfUsOrCanada: false,
                            noneOfThese: false
                        },
                        naturalizedCitizenshipIndicator: true,
                        livedIntheUSSince1996Indicator: false,
                        naturalizationCertificateNaturalizationNumber: ''
                    },
                    medicalExpense: null,
                    specialEnrollmentPeriod: {
                        birthOrAdoptionEventIndicator: false
                    },
                    marriedIndicator: null,
                    bloodRelationship: [],
                    drugFellowIndicator: false,
                    livingArrangementIndicator: false,
                    taxFiler: {
                        spouseHouseholdMemberId: 0,
                        claimingDependantsOnFTRIndicator: null,
                        taxFilerDependants: [
                            {
                                dependantHouseholdMemeberId: 0,
                                taxFilerDependantIndicator: false
                            }
                        ],
                        liveWithSpouseIndicator: null
                    },
                    shelterAndUtilityExpense: null,
                    tobaccoUserIndicator: false,
                    dependentCareExpense: null,
                    residencyVerificationIndicator: false,
                    taxFilerDependant: {
                        dependantHouseholdMemeberId: null,
                        taxFilerDependantIndicator: null
                    },
                    name: {
                        middleName: 'George',
                        lastName: 'Blacksmith',
                        firstName: 'Nataniel',
                        suffix: 'Jr.'
                    },
                    ethnicityAndRace: {
                        ethnicity: [],
                        race: [
                            {
                                label: 'Argentinian',
                                code: '2131-1',
                                otherLabel: null
                            }
                        ],
                        hispanicLatinoSpanishOriginIndicator: false
                    },
                    personId: 3,
                    addressId: 1,
                    householdId: 0,
                    gender: 'male',
                    SSIIndicator: false,
                    IPVIndicator: false,
                    householdContactIndicator: true,
                    americanIndianAlaskaNative: {
                        tribeName: 'ND380475',
                        tribeFullName: null,
                        state: 'ND',
                        stateFullName: null,
                        memberOfFederallyRecognizedTribeIndicator: true,
                        americanIndianAlaskaNativeSelfIdentification: true
                    },
                    householdContact: {
                        homeAddressIndicator: true,
                        phone: {
                            phoneExtension: '',
                            phoneNumber: '',
                            phoneType: 'CELL'
                        },
                        homeAddress: {
                            postalCode: '',
                            countyCode: null,
                            county: '',
                            primaryAddressCountyFipsCode: '',
                            streetAddress1: '',
                            streetAddress2: '',
                            state: '',
                            city: ''
                        },
                        stateResidencyProof: '',
                        otherPhone: {
                            phoneExtension: '',
                            phoneNumber: '',
                            phoneType: 'HOME'
                        },
                        contactPreferences: {
                            emailAddress: '',
                            preferredSpokenLanguage: '',
                            preferredContactMethod: '',
                            preferredWrittenLanguage: ''
                        },
                        mailingAddress: {
                            postalCode: '',
                            countyCode: null,
                            county: '',
                            primaryAddressCountyFipsCode: null,
                            streetAddress1: '',
                            streetAddress2: '',
                            state: '',
                            city: ''
                        },
                        mailingAddressSameAsHomeAddressIndicator: true
                    },
                    PIDVerificationIndicator: false,
                    applicantGuid: '1001016687',
                    PIDIndicator: false,
                    applyingForCoverageIndicator: true,
                    planToFileFTRJontlyIndicator: null,
                    livesAtOtherAddressIndicator: false,
                    healthCoverage: {
                        chpInsurance: {
                            reasonInsuranceEndedOther: '',
                            insuranceEndedDuringWaitingPeriodIndicator: false
                        },
                        haveBeenUninsuredInLast6MonthsIndicator: null,
                        currentEmployer: [
                            {
                                employer: {
                                    phone: {
                                        phoneExtension: '',
                                        phoneNumber: '',
                                        phoneType: 'HOME'
                                    },
                                    employerContactPersonName: '',
                                    employerContactEmailAddress: ''
                                },
                                currentEmployerInsurance: {
                                    currentLowestCostSelfOnlyPlanName: '',
                                    willBeEnrolledInEmployerPlanIndicator: false,
                                    memberEmployerPlanStartDate: null,
                                    willBeEnrolledInEmployerPlanDate: null,
                                    comingPlanMeetsMinimumStandardIndicator: false,
                                    memberPlansToDropEmployerPlanIndicator: true,
                                    employerWillOfferPlanIndicator: true,
                                    expectedChangesToEmployerCoverageIndicator: true,
                                    employerCoverageEndingDate: null,
                                    memberPlansToEnrollInEmployerPlanIndicator: true,
                                    employerPlanStartDate: null,
                                    memberEmployerPlanEndingDate: null,
                                    comingLowestCostSelfOnlyPlanName: '',
                                    currentPlanMeetsMinimumStandardIndicator: false,
                                    employerWillNotOfferCoverageIndicator: false,
                                    isCurrentlyEnrolledInEmployerPlanIndicator: false,
                                    insuranceName: null,
                                    policyNumber: null
                                }
                            }
                        ],
                        currentlyHasHealthInsuranceIndicator: false,
                        currentOtherInsurance: {
                            otherStateOrFederalMedicaidProgramName: 'Medicaid',
                            otherStateOrFederalCHIPProgramName: 'Nevada Check Up',
                            otherStateOrFederalPrograms: [],
                            currentlyEnrolledInVeteransProgram: false,
                            hasNonESI: false
                        },
                        otherInsurance: {
                            insuranceName: '',
                            policyNumber: '',
                            limitedBenefit: false
                        },
                        formerEmployer: [
                            {
                                phone: {
                                    phoneExtension: '',
                                    phoneNumber: '',
                                    phoneType: 'CELL'
                                },
                                employerName: '',
                                employerIdentificationNumber: '',
                                employerContactPersonName: '',
                                address: {
                                    postalCode: '',
                                    county: null,
                                    primaryAddressCountyFipsCode: null,
                                    streetAddress1: '',
                                    streetAddress2: '',
                                    state: '',
                                    city: ''
                                },
                                employerContactPhone: {
                                    phoneExtension: '',
                                    phoneNumber: '',
                                    phoneType: 'HOME'
                                },
                                employerContactEmailAddress: ''
                            }
                        ],
                        primaryCarePhysicianName: '',
                        otherInsuranceIndicator: true,
                        currentlyEnrolledInCobraIndicator: null,
                        employerWillOfferInsuranceIndicator: null,
                        currentlyEnrolledInRetireePlanIndicator: null,
                        currentlyEnrolledInVeteransProgramIndicator: null,
                        hasPrimaryCarePhysicianIndicator: false,
                        employerWillOfferInsuranceCoverageStartDate: null,
                        willBeEnrolledInCobraIndicator: null,
                        willBeEnrolledInVeteransProgramIndicator: null,
                        medicaidInsurance: {
                            requestHelpPayingMedicalBillsLast3MonthsIndicator: false
                        },
                        isOfferedHealthCoverageThroughJobIndicator: null,
                        willBeEnrolledInRetireePlanIndicator: null,
                        employerWillOfferInsuranceStartDate: null,
                        stateHealthBenefit: null,
                        eligibleITU: null,
                        receivedITU: null,
                        unpaidBill: null,
                        coveredDependentChild: null,
                        absentParent: null
                    },
                    planToFileFTRIndicator: null,
                    otherAddress: {
                        address: {
                            postalCode: '90055',
                            county: '',
                            countyCode: 'Santa Clara',
                            primaryAddressCountyFipsCode: null,
                            streetAddress1: '',
                            streetAddress2: '',
                            state: 'MO',
                            city: ''
                        },
                        livingOutsideofStateTemporarilyAddress: {
                            postalCode: '',
                            county: '',
                            primaryAddressCountyFipsCode: null,
                            streetAddress1: '',
                            streetAddress2: '',
                            state: '',
                            city: ''
                        },
                        livingOutsideofStateTemporarilyIndicator: null
                    },
                    heatingCoolingindicator: false,
                    incarcerationStatus: {
                        incarcerationManualVerificationIndicator: false,
                        incarcerationStatusIndicator: false,
                        useSelfAttestedIncarceration: false,
                        incarcerationPendingDispositionIndicator: false,
                        incarcerationAsAttestedIndicator: false
                    },
                    infantIndicator: false,
                    childSupportExpense: null,
                    expeditedIncome: {
                        irsReportedAnnualIncome: null,
                        expectedAnnualIncomeUnknownIndicator: null,
                        irsIncomeManualVerificationIndicator: false,
                        expectedAnnualIncome: null
                    },
                    migrantFarmWorker: true,
                    status: 'ADD_NEW',
                    mediciadChipDenial: false,
                    under26Indicator: true,
                    externalId: null
                }
            ],
            'houseHoldIncome': null,
            'applyingForCashBenefitsIndicator': false,
            'deletedHouseholdMember': [],
            'primaryTaxFilerPersonId': 1,
            'reconciledAptc': true,
            'otherAddresses': [
                {
                    'postalCode': '89145',
                    'county': 'Clark',
                    'primaryAddressCountyFipsCode': '32003',
                    'streetAddress1': '9433 Garnet Crown Ave',
                    'streetAddress2': null,
                    'state': 'NV',
                    'city': 'Las Vegas',
                    'countyCode': '32003',
                    'addressId': 1
                }
            ],
            'annualTaxIncome': {
                'reportedIncome': 3000000,
                'projectedIncome': 0,
                'incomeLessExplainedIndicator': null,
                'incomeExplanationRequiredIndicator': true,
                'unknownIncomeIndicator': null,
                'variableIncomeIndicator': null,
                'taxHouseholdIncomeDiscrepancyDescriptionText': null,
                'taxHouseholdIncomeDifferenceReasonType': [],
                'variableIncomeDescriptionText': null,
                'taxHouseholdIncomeDifferenceReason': 'OTHER'
            },
            'failureToReconcile': false,
            'medicaidConsent': null,
            'requiredVerifications': [],
            'reconcileAptcOption': 'reconciled',
            'unemploymentIncome': false
        }
    ],
    'incarcerationAsAttestedIndicator': null,
    'aptcDetectedLowFPLEventIndicator': null,
    'mecCheckStatus': null,
    'jointTaxFilerSpousePersonId': null,
    'currentApplicantId': null,
    'ssapVersion': null,
    'exemptHousehold': null,
    'brokerChanged': null,
    'renewalConsentChanged': null,
    'incomeConsentChanged': null,
    'isEditApplication': null,
    'manuallyCreated': true,
    'claimNoticeDMAHSAcknowledgment': false,
    'paybackDMAHSAcknowledgment': false,
    'uiProperties': '{"ssapFlowVersion":2}',
    removedMembers: {
        '1060619904': {
            demographic: {
                birthDate: '1922-08-29',
                deathDate: '2022-12-28',
                divorceDate: null,
                name: {
                    firstName: 'Eric',
                    middleName: 'Anders',
                    lastName: 'Odinson',
                    suffix: 'II'
                },
                otherDate: null
            },
            removalReasonType: 'DEATH'
        },
        '1060619921': {
            demographic: {
                birthDate: '1944-09-21',
                deathDate: null,
                divorceDate: '1999-07-14',
                name: {
                    'firstName': 'Jack',
                    'middleName': 'Kenneth',
                    'lastName': 'Svensen',
                    'suffix': 'III'
                },
                otherDate: null
            },
            removalReasonType: 'DIVORCE'
        },
        '1060619999': {
            demographic: {
                birthDate: '2008-03-08',
                deathDate: null,
                divorceDate: null,
                name: {
                    'firstName': 'Joan',
                    'middleName': 'Felecia',
                    'lastName': 'Storm',
                    'suffix': null
                },
                otherDate: null
            },
            removalReasonType: 'OTHER'
        }
    },
    'runMode': null,
    'externalApplicationId': null,
    'outboundCaseNumber': null,
    'ridpVerified': false,
    'ip': null,
    'editApplication': null
};